import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../lib/data";
import { LoanPortfolio } from "../components/LoanPortfolio";
import { ServiceBreakdown } from "../components/ServiceBreakdown";
import { ServicesBanner } from "../components/ServicesBanner";

export default function Services() {
  return (
    <div data-testid="services-page">
      <ServicesBanner />
      <section className="container-x section-pad service-breakdowns" data-testid="service-breakdowns">
        {SERVICES.map((service) => <ServiceBreakdown key={service.id} service={service} />)}
      </section>
      <section className="portfolio-section section-pad" data-testid="services-portfolio">
        <div className="container-x">
          <span className="accent-bar mb-3" />
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy mb-10">Loan Solutions Portfolio</h2>
          <LoanPortfolio />
          <Link to="/contact#lead" className="mt-10 inline-flex items-center gap-2 bg-brandred hover:bg-brandred-700 text-white px-6 py-3 text-sm font-bold uppercase tracking-wider rounded-sm" data-testid="services-cta">Apply for Funding <ArrowUpRight size={18} /></Link>
        </div>
      </section>
    </div>
  );
}